import React from "react";

export default function Footer() {
  return (
    <footer className="footer bg-dark text-white py-4">
      <div className="container">
        <div className="d-flex flex-wrap justify-content-between align-items-center text-center pt-5">

          {/* App buttons */}
          <div className="mb-2 mb-lg-0">
            <button className="btn btn-light me-2" > <a className="btn btn-light me-2"  target="_blank"
  rel="noopener noreferrer" href={"https://apps.apple.com/au/app/yasa-app/id6755378597"}>App Store</a></button>
            <button className="btn btn-light me-2" > <a className="btn btn-light me-2"  target="_blank"
  rel="noopener noreferrer" href={"https://play.google.com/store/apps/details?id=com.zanyar_fb.yasaapp&pcampaignid=web_share"}>Google Play</a></button>
            
          </div>

          {/* Phone */}
          <div className="mb-2 mb-lg-0">
            <span>0751 660 6061</span>
          </div>

          {/* Email */}
          <div>
            <span>info@yasa-app.com</span>
          </div>

        </div>
      </div>
    </footer>
  );
}
